<script lang="ts">
	import { onDestroy } from 'svelte';
	import { format } from 'svelte-i18n';
	import { formatTimeLeft } from 'src/helpers/utilities';
	import { Label, LabelList } from '@Shelly/shelly-design-system/index';
	import type { LabelProps } from '@Shelly/shelly-design-system/index';

	export let targetTime: number | null = null; // Unix timestamp (in milliseconds)

	const INTERVAL_MS = 1000;

	let labelList: LabelProps[] | null = null;
	let interval: ReturnType<typeof setInterval> | undefined;

	const stopCountdown = () => {
		if (!interval) return;

		clearInterval(interval);
		interval = undefined;
	};

	const updateCountdown = (time: number) => {
		const secondsLeft = Math.max(0, Math.round((time - Date.now()) / 1000));
		labelList = formatTimeLeft(secondsLeft) as LabelProps[];

		if (secondsLeft === 0) {
			stopCountdown();
		}
	};

	const startCountdown = (time: number | null) => {
		stopCountdown();

		if (!time) {
			labelList = null;
			return;
		}

		updateCountdown(time);

		interval = setInterval(() => {
			updateCountdown(time);
		}, INTERVAL_MS);
	};

	$: startCountdown(targetTime);

	onDestroy(stopCountdown);
</script>

{#if labelList && labelList.length > 1}
	<div class="label-list">
		<LabelList size="m" {labelList} />
	</div>
{/if}

{#if !labelList}
	<Label icon="fas fa-clock" value={$format('calculate_time')} type="primary" size="m" />
{/if}

<style>
	.label-list {
		user-select: none;
		pointer-events: none;
	}
</style>
